import React from "react";
import { Helmet } from "react-helmet";
import HeaderTitle from "../../../components/header/headerTitle/headerTitle";
import Image from "../../../components/image";
import { asset } from "../../../helpers/dom.helper";
import "./style.scss";
import {JEWELRY_BOXES} from './jewelryBoxesJson'
import { Link } from "react-router-dom";
import { toRoute } from "../../../i18n";
import { Media, MediaContextProvider } from "../../../media";
import WhyLussopackMoreInfo from "../../../components/whyLussopack/whyLussoPackMoreInfo";

function JewelryBoxes(props) {
  const contentDescription = (
    <div className="jewelryBoxesDetails mb-5">
      <h2 className="mb-4">Luxury Jewelry Packaging Boxes to Showcase Your Pieces</h2>
      <p>Luxury jewelry packaging boxes are designed to protect and <a href='https://lussopack.com/packaging/jewelry-displays' target="_blank">display precious jewelry pieces</a> while offering a refined aesthetic. These boxes are crafted from premium materials, including fine wood and ornate metals, ensuring durability and elegance. Practical features like cushioned holders and compartments help organize and secure items such as rings, necklaces, and bracelets.</p>
      <h2 className="mb-4 mt-5">Key Features of Jewelry Packaging Boxes</h2>
      <h3>Designed for Versatility</h3>
      <p>These packaging boxes cater to a wide variety of jewelry pieces, with tailored compartments and holders for specific items. Whether it’s a necklace requiring an elegant arrangement or rings needing snug cushioning, each design ensures functionality and appeal.</p>
      <h3>Customization Options for Unique Branding</h3>
      <p>Jewelry packaging boxes wholesale can be customized to align with specific branding requirements. Options include premium finishes, custom sizes, and personalized colors, making it easy to create packaging that reflects your brand’s identity. Logos, patterns, and other design elements can also be incorporated seamlessly.</p>
      <h3>Premium Materials for a Luxurious Feel</h3>
      <p><a href="https://lussopack.com/our-materials" target="_blank">Crafted from high-quality materials</a>, such as natural wood, velvet interiors, or metallic accents, these boxes exude sophistication. Each material is chosen to enhance the packaging's overall durability and aesthetic, providing a fitting presentation for luxury jewelry.</p>
      <h3>Eco-Friendly Choices</h3>
      <p>For businesses seeking sustainable solutions, eco-friendly packaging options are available. These boxes are crafted from responsibly sourced materials without compromising on quality or style, offering an ideal choice for environmentally conscious jewelers.</p>
      <h3>Durability and Practicality</h3>
      <p>Built to last, these packaging boxes are designed to protect valuable jewelry over time. The combination of sturdy construction and functional compartments ensures both safety and ease of use, making them a reliable option for long-term storage or display.</p>
    </div>
  )
  const summaryDescription = (
    <div className='summaryDescription'>
      <h2 className='mb-3 mt-5'>Lussopack: Your Custom Luxury Wholesale Jewelry Bags Partner</h2>
      <p>Based in Bangkok, Thailand, Lussopack is a leading luxury jewelry bag manufacturer with over 30 years of expertise, delivering exceptional quality and personalized service.</p>
      <h3 className="mb-2">More Than Wholesale Jewelry Bags Manufacturing</h3>
      <p>We work with clients to craft luxury jewelry pouches that foster emotional connections, build brand loyalty, and inspire advocacy.</p>
      <h3 className="mb-2">Broad Specialization</h3>
      <p>From jewelry packaging, and jewelry display to custom designs for high-end brands like perfume, rigid, and gift boxes, we ensure superior craftsmanship in every product.</p>
      <h3 className="mb-2">Tailor-Made Solutions for Jewelry Pouches</h3>
      <p>Choose from an extensive range of premium materials and finishes, or work with our experts to develop bespoke packaging that embodies your brand's essence.</p>
      <h3 className="mb-2">Efficient Logistics Services</h3>
      <p>Take advantage of our warehousing, distribution, and direct packaging solutions to streamline operations, cut costs, and manage your supply chain with ease.</p>
      <h3 className="mb-2">Client-Focused Commitment</h3>
      <p>At Lussopack, we are passionate about delivering flawless luxury watch box solutions that align with your brand’s vision and exceed your expectations.</p>
      <h3 className="mb-2">Contact Us Today</h3>
      <p>Let us help bring your luxury watch box vision to life. Reach out to our team and discover how we can create the perfect solution for your brand.</p>
  </div>
  )


  return (
    <>
      <Helmet>
        <title>Custom Luxury Jewelry Packaging Boxes Supplier | Lussopack</title>
        <meta name="description" content="As trusted jewelry packaging suppliers, we offer wholesale/bulk boxes, crafted from high-quality, eco-friendly materials to suit your brand's needs." />
        <meta name="keywords" content="Jewelry Packaging Boxes" />    
        <link rel="canonical" href="https://lussopack.com/packaging/" />  
      </Helmet>

      {/* <ScrollToTopOnMount /> */}
      <HeaderTitle
        {...props}
        textHeader={"Custom Luxury Jewelry Packaging Boxes"}
        textSubHeader={"Our custom jewelry packaging boxes are designed to showcase and protect your precious jewelry with unmatched craftsmanship and luxurious materials."}
        isShowOurReference={true}
      />      
        <MediaContextProvider> 
          <Media greaterThanOrEqual="md">
            <div id="jewelryBoxes">
              <h2 className="text-center">High-Quality Luxury Jewelry Boxes</h2>
              <div className="jewelryBoxesList">
                {
                  JEWELRY_BOXES.map((jewelry, index)=>(
                    <div className="jewelryBoxesItem" key={index}>
                      <Link to={toRoute(jewelry.path)}>
                      <Image
                        src={asset(`${jewelry.itemImageDesktop}`)}
                        alt={`${jewelry.item}`}
                        className="img-fluid zoom"
                        width="345"
                        height="345"
                      />                  
                      </Link>
                      <Link to={toRoute(jewelry.path)}>
                        <p className="text-center mt-2">{jewelry.item}</p>
                      </Link>
                    </div>
                  ))
                }
              </div>              
              
              {contentDescription}
              <WhyLussopackMoreInfo />
              {summaryDescription}
            </div>
          </Media>
          <Media lessThan="md">
            <div id="jewelryBoxesMobile">
              <h2>High-Quality Luxury Jewelry Boxes</h2>
              <div className="jewelryBoxesList">
                {
                  JEWELRY_BOXES.map((jewelry, index)=>(
                    <div className="jewelryBoxesItem" key={index}>
                      <Link to={toRoute(jewelry.path)}>
                      <Image
                        src={asset(`${jewelry.itemImageDesktop}`)}
                        alt={`${jewelry.item}`}
                        className="img-fluid"
                        width="345"
                        height="345"
                      />                  
                        <p>{jewelry.item}</p>
                      </Link>
                    </div>
                  ))
                }
              </div>
              {contentDescription}
              <WhyLussopackMoreInfo />
              {summaryDescription}     
            </div>            
          </Media>
        </MediaContextProvider>
    </>
  );
}

export default JewelryBoxes;
